import axios from 'axios';
import AxiosFormData from "../../helpers/AxiosFormData";
/**
 * Makes a fetch request to the specified URL using the provided parameters.
 *
 * @param {Object} params - The parameters for the fetch request.
 * @param {string} method - The HTTP method for the request.
 * @return {Promise<Object | boolean>} - A promise that resolves to the response data or false if there was an error.
 */
async function makeFetchRequest(params, method) {
    const { baseUrl, route = '', body, headers: customHeaders } = params;
    const url = baseUrl + route;

    let headers = new Headers(customHeaders);
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");

    const requestOptions = {
        method: method,
        headers: headers,
        data: AxiosFormData(body),
        url: url
    };

    try {
        const response = await axios(requestOptions);
        if (response.status !== 200) {
            console.error('HTTP error:', response.status, response.statusText);
            return {
                success: false,
                data: null,
                status: response.status,
                error: `HTTP error: ${response.status} - ${response.statusText}`
            };
        }

        const data = await response.data ? response.data : null;
        return {
            success: true,
            data: data,
            status: response.status,
            error: null
        };
    } catch (error) {
        console.error(`Error in ${method} request:`, error);
        return {
            success: false,
            data: null,
            status: null,
            error: error.message
        };
    }

}

const getService = async (params) => {
    return await makeFetchRequest(params, 'GET');
};

const postService = async (params) => {
    return await makeFetchRequest(params, 'POST');
};

const putService = async (params) => {
    return await makeFetchRequest(params, 'PUT');
};

const deleteService = async (params) => {
    return await makeFetchRequest(params, 'DELETE');
};

// Exporting the functions
export { getService, postService, putService, deleteService };
